"use strict";

// PATCHED 2026-08-18 ΓÇö two fixes:
//  (1) Render in place when the theme's "Recommended products" BLOCK
//      ([data-product-recommendations-container]) is absent. Without this the
//      fetched markup was injected into nothing and the section then hid itself,
//      leaving a heading with zero products.
//  (2) Prefer CURATED "complementary" products (set in Shopify Search &
//      Discovery) and fall back to Shopify's algorithmic "related" products when
//      a product has no curated pairs. Heading switches to match.

Shopify.theme.jsRecommendedProducts = {
  init: function init($section) {
    Shopify.theme.jsRecommendedProducts = $.extend(this, Shopify.theme.getSectionData($section));

    var $productRecommendations = $section.find('.product-recommendations');
    var $productRecommendationsContainer = $('[data-product-recommendations-container]');

    var renderInPlace = $productRecommendationsContainer.length === 0;
    if (renderInPlace) {
      $productRecommendationsContainer = $productRecommendations;
    }

    var $productRecommendationsBlock = renderInPlace
      ? $section
      : $productRecommendationsContainer.closest('.block__recommended-products');

    if (this.show_product_recommendations === false) {
      $productRecommendationsBlock.hide();
      return;
    }

    $('.recommended-products-section').show();
    $productRecommendationsBlock.show();
    var productId = $productRecommendations[0].dataset.productId;
    var limit = $productRecommendations[0].dataset.limit;
    var sectionEnabled = $productRecommendations[0].dataset.enabled;

    if (this.show_custom_collection) {
      this.showCustomCollection($section);
      return;
    }

    function buildUrl(intent) {
      return "/recommendations/products?section_id=product__recommendations&limit=" +
        limit + "&product_id=" + productId + "&intent=" + intent;
    }

    function render(html, intent) {
      var $fetched = $(html).find('.product-recommendations');
      if ($fetched.find('.thumbnail').length === 0) return false;

      $productRecommendationsContainer.html($fetched.html());

      // Curated pairs read better under a "goes with this" style heading.
      if (intent === 'complementary') {
        $productRecommendationsContainer
          .find('.recommended-products__title')
          .text('Pairs well with');
      }

      if (!renderInPlace) {
        $('.recommended-products-section').hide();
      }
      Shopify.theme.jsProduct.relatedProducts();
      if (Currency.show_multiple_currencies) {
        convertCurrencies();
      }
      return true;
    }

    if (!sectionEnabled) {
      $productRecommendationsContainer.empty();
      return;
    }

    // Try curated complementary products first, then fall back to related.
    $.get(buildUrl('complementary'))
      .done(function (complementaryHtml) {
        if (render(complementaryHtml, 'complementary')) return;
        $.get(buildUrl('related'))
          .done(function (relatedHtml) {
            if (!render(relatedHtml, 'related')) $productRecommendationsBlock.hide();
          })
          .fail(function () { $productRecommendationsBlock.hide(); });
      })
      .fail(function () {
        $.get(buildUrl('related'))
          .done(function (relatedHtml) {
            if (!render(relatedHtml, 'related')) $productRecommendationsBlock.hide();
          })
          .fail(function () { $productRecommendationsBlock.hide(); });
      });
  },
  showCustomCollection: function showCustomCollection($section) {
    var $recommendedProductsElement = $section.find('.product-recommendations').html();
    var $productRecommendationsContainer = $('[data-product-recommendations-container]');

    if ($productRecommendationsContainer.length === 0) {
      $('.recommended-products-section').show();
      Shopify.theme.jsProduct.relatedProducts();
      return;
    }

    $productRecommendationsContainer.html($recommendedProductsElement);
    $('.recommended-products-section').hide();
    Shopify.theme.jsProduct.relatedProducts();
  },
  unload: function unload($section) {}
};
